export enum DormerType {
  None = 'none',
  GableDormer = 'gable-dormer',
  ShedDormer = 'shed-dormer',
}
